export default function ($scope, $location, $window) {
    //AuthenticationService.ClearCredentials();


    if(Cookies.get('loading') && GetData()){
        let path = Cookies.get('loading_path') || '/account';
        Cookies.remove('loading');
        Cookies.remove('loading_path');

        $location.path(path);
    }
    else{
        Cookies.set('loading', true);
        $window.location.reload();
    }

};


/** WEBPACK FOOTER **
 ** ./js/theme/loading/controller.js
 **/